module.exports = __webpack_public_path__ + "static/media/glasses-icon-mobile.9dee9fb9.svg";